import React, { Component } from 'react';
import { Form, FormGroup, Button, Row, Collapse } from 'reactstrap';
import { func } from 'prop-types';
import compact from 'lodash/compact';
import { FMessage } from '../../../../hoc/IntlComponents';
import ContractsIPForm from './ContractsIPForm';
import ContractsOOOForm from './ContractsOOOForm';
import ContractsFormControls from '../../../../components/Contracts/ContractFormControls';
import fieldProps from '../../../../components/Contracts/fieldProps';
import CustomControl from '../../../../components/CustomControl/CustomControl';

const required = {
    ip: [
        'name',
        'ogrnip',
        'inn',
        'address',
        'actual_address',
        'email',
        'phone',
        'bank_name',
        'bank_account',
        'bik',
        'corr_account',
        'edo_id'
    ],
    ooo: [
        'name',
        'owner',
        'ogrn',
        'inn',
        'kpp',
        'address',
        'actual_address',
        'contact_name',
        'email',
        'phone',
        'bank_name',
        'bank_account',
        'bik',
        'corr_account',
        'edo_id',
    ]
};

class ContractsForm extends Component {
    static propTypes = {
        onSubmit: func.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            ip: props.selected ? props.selected : {},
            ooo: props.selected ? props.selected : {},
            errors_ip: [],
            errors_ooo: [],
            isFormOpened: false,
            isNotResident: true,
        };
    }

    onInputChange = ({ target: { name, value } }) => {
        const { type: contractType, types, inModal } = this.props;
        let type = !inModal ? types[contractType] : contractType;

        this.setState(prevState => {
            const prevErrors = prevState[`errors_${type}`];
            const errorIndex = prevErrors.findIndex(value => value === name);
            let nextErrors = [...prevErrors];
            if (errorIndex >= 0) {
                nextErrors[errorIndex] = null;
            }
            return {
                [type]: {
                    ...prevState[type],
                    [name]: value,
                },
                [`errors_${type}`]: compact(nextErrors),
            };
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!nextProps.loading === true && this.props.loading) {
            this.setState(() => ({ isFormOpened: false }));
        }
    }

    getCommonProps = (key, labelIndex) => {
        const { disabled, types, type: contractType, inModal } = this.props;

        let type = !inModal ? types[contractType] : contractType;
        let value = this.state[type][key];

        const {
            labelId,
            ...restProps
        } = fieldProps[key];
        const error = this.state[`errors_${type}`].find(field => field === key);
        const commonProps = {
            ...restProps,
            bsSize: 'sm',
            name: key,
            value: value ? value : '',
            onChange: this.onInputChange,
            disabled,
            error: error ? <FMessage id='main.error.required' /> : '',
        };

        if (labelId) {
            commonProps.id = `contracts.${labelIndex >= 0 ? labelId[labelIndex] : labelId}.kma`;
        }
        return commonProps;
    }
    getCustomCheckBoxId = type => {
        const { inModal } = this.props;
        return `contracts.checkbox.${type}${inModal ? '.inModal' : ''}`;
    }
    toggleForm = () => {
        this.setState(({ isFormOpened }) => ({ isFormOpened: !isFormOpened }));
    }

    handleSubmit = e => {
        e.preventDefault();
        const { onSubmit, toggleModal, inModal } = this.props;
        const currentType = this.getFormType();
        const data = this.state[currentType];
        if (!this.isInvalid(currentType, data)) {
            onSubmit(data);
            if (inModal) {
                toggleModal();
            }
        }
    }
    isInvalid = (type, data) => {
        const errors = [];

        required[type].forEach(field => {
            if (!data[field] || !data[field].toString().length) {
                errors.push(field);
            }
        });
        this.setState(() => ({ [`errors_${type}`]: errors }));
        return errors.length;
    }

    getFormType = () => {
        const { types, type, inModal } = this.props;
        if (!inModal) {
            return types[type];
        } else {
            return type;
        }
    }

    handleChangeResident = () => this.setState(prevState => ({ isNotResident: !prevState.isNotResident }));

    render() {
        const { isFormOpened, isNotResident } = this.state;
        const { types, handleTypeChange, inModal, toggleModal, disabled } = this.props;
        const type = this.getFormType();
        return (
            <div className="contracts-form">
                {/* {!inModal &&
          <div
            className={`toggleBtn link ${isFormOpened ? 'padding-bottom' : ''}`}
            onClick={this.toggleForm}>
            <span className='collapse-symbol'>{isFormOpened ? '-' : '+'}</span>
            <FMessage id="contracts.details.add.btn" />
          </div>
        } */}
                <Form onSubmit={this.handleSubmit} autoComplete="off">
                    <Collapse isOpen={true}>
                        {!inModal &&
                            <ContractsFormControls
                                types={types}
                                active={this.props.type}
                                handleTypeChange={handleTypeChange} />
                        }
                        <Row>
                            {type === 'ip' &&
                                <ContractsIPForm
                                    getCommonProps={this.getCommonProps}
                                    inModal={inModal}
                                    customCheckBoxId={this.getCustomCheckBoxId('ip')}
                                    disabled={disabled} />
                            }
                            {type === 'ooo' &&
                                <ContractsOOOForm
                                    getCommonProps={this.getCommonProps}
                                    inModal={inModal}
                                    customCheckBoxId={this.getCustomCheckBoxId('ooo')}
                                    disabled={disabled} />
                            }
                        </Row>

                        <FormGroup>
                            <CustomControl
                                id={`isNotResident_${inModal ? this.state[type].id : ''}`}
                                className="custom-control-xs isNotResident"
                                name="isNotResident"
                                value='isNotResident'
                                onChange={this.handleChangeResident}
                                checked={isNotResident}
                                disabled={disabled}>
                                <FMessage id="contracts.residend" />
                            </CustomControl>
                        </FormGroup>

                        <FormGroup className='form-controls'>
                            {inModal &&
                                <Button
                                    className="btn btn-sm"
                                    color="light"
                                    onClick={toggleModal}>
                                    <FMessage id="main.cancel" />
                                </Button>
                            }
                            <Button
                                type='submit'
                                className="btn btn-sm"
                                color="primary"
                                onClick={this.onSubmit}
                                disabled={!isNotResident || disabled}>
                                <FMessage id={!inModal ? 'contracts.details.add.btn' : 'main.save'} />
                            </Button>
                        </FormGroup>
                    </Collapse>
                </Form>
            </div>
        );
    }
}

export default ContractsForm;